import { render, staticRenderFns } from "./AlarmNoticeTable.vue?vue&type=template&id=0b838b19&"
import script from "./AlarmNoticeTable.vue?vue&type=script&lang=js&"
export * from "./AlarmNoticeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports